<template>
  <v-card flat outlined>
    <v-card-title class="headline text-center d-block">{{ title }}</v-card-title>
    <v-card-text>
      <div class="subtitle-1 text-center">Today</div>
    </v-card-text>

    <v-card
        class="d-flex justify-space-around flex-wrap mb-6`"
        flat
        tile
    >
      <v-card
          v-for="(label, n) in todayLabels"
          :key="n"
          class="pa-2 text-center mb-1"
          flat
          dark
          :color="['blue','teal','green','red','orange'][n]"
          style="border-radius: 4px !important;"
      >
        <span class="overline" style="text-overflow: ellipsis;">{{label}}</span><br>
        <span
            class="display-1">{{ getTodayLatest(label) }}</span>
      </v-card>
    </v-card>
    <div class="mt-2 subtitle-1 text-center">Total</div>
    <doughnut-chart :title="title" :graph-data="chartData"/>
  </v-card>
</template>
<script>
    // import {mapGetters} from 'vuex'
    import * as color from './colors'
    import DoughnutChart from '../Charts/Doughnut'


    export default {
        components: {DoughnutChart},
        name: 'ApplicationsCard',
        props: {
            title: String,
            metrics: Object
        },
        data() {
            return {
                todayLabels: [
                    'New', 'Approved', 'Closed', 'Declined', 'Withdrawn'
                ],
                graphLabels: [
                    'Processing',
                    'Closed',
                    'Declined',
                    'Withdrawn',
                ],
                graphColors: [
                    color.BLUE,
                    color.GREEN,
                    color.RED,
                    color.ORANGE,
                ]
            }
        },
        computed: {
            chartData() {
                const data = {
                    datasets: [
                        {
                            'label': this.title,
                            'data': this.graphLabels.map(l => this.getInstantLatest(l)),
                            backgroundColor: this.graphColors,
                        }
                    ],
                    labels: this.graphLabels
                }
                return data
            }
        },
        methods: {
            getTodayLatest(label) {
                const metricSlug = label.toLowerCase() + '-applications-today'
                try {
                    const metric = this.metrics[metricSlug]
                    let latest = metric.data.slice(-1)[0]
                    return latest[1]
                } catch (e) {
                    return '-'
                }
            },
            getInstantLatest(label) {
                const metricSlug = label.toLowerCase() + '-applications'
                try {
                    const metric = this.metrics[metricSlug]
                    let latest = metric.data.slice(-1)[0]
                    return latest[1]
                } catch (e) {
                    return 0
                }
            }
        }
    }
</script>